import { breedTypeElements } from '@flows/configs/petHealthV2/steps/elements/breeds'
import { fragmentStep } from '@flows/configs/shared/stepFragments'
import type { StepConfigParams } from '@flows/configs/types'

const breed_type = (params: StepConfigParams) =>
  fragmentStep(breedTypeElements(params), params, {
    valuePath: params.helperFunctions.getParamPath('breed_type'),
    valueToStepName: { pedigree: 'pure_breed_name', crossbreed: 'cross_breed_names' },
  })

export default breed_type
